module.exports = [
  {
    "id": "1",
    "first_name": "Catherine",
    "last_name": "Caufield",
    "nickname": "Klassic Kat",
    "description": "Classic Kat is all about the classic boxing combos - in fact her devastating style doesn't use anything else!",
    "img": "images/kafka.webp"
  },

  {
    "id": "2",
    "first_name": "Randy",
    "last_name": "Rendell",
    "nickname": "Random",
    "description": "Random Randy Rendell is completely unpredictable, and has a seemingly endless list of combinations, which makes him confusing to match... However, not all of his combinations are efficient!",
    "img": "images/rendell.png"
  },
  
  {
    "id": "3",
    "first_name": "Gennadiy",
    "last_name": "Golovkin",
    "nickname": "GGG",
    "description": "Triple G is a power fighter. He'll throw everything and the kitchen sink at his opponent with wild variations, notably his feared and unusual overhand lead jab.",
    "img": "images/ggg.png"
  },
  {
    "id": "4",
    "first_name": "Canelo",
    "last_name": "Alvarez",
    "nickname": "",
    "description": "Canelo Alvarez uses speed and power to overwhelm his opponent. Expect intricate combos with brutally short time to recover or readjust between maneuvers.",
    "img": "images/canelo.png"
  },
  {
    "id": "5",
    "first_name": "Mike",
    "last_name": "Tyson",
    "nickname": "Iron Mike",
    "description": "Mike Tyson is the ultimate pressure machine, using updated forms of Joe Frasier's peekaboo style in a devastating manner. He is extremely mobile - expect a lot of slips, ducks and switching.",
    "img": "images/tyson.png"
  },

  {
    "id": "6",
    "first_name": "Manny",
    "last_name": "Pacquiao",
    "nickname": "Pacman",
    "description": "With a record of 62-8-2 and being the only professional boxer to win eight different division world championships, Pacman is King of the Southpaws. Short, fast combinations are his forte, so expect a lot of repetitions of short, powerful, clean shots",
    "img": "images/pacquiao.png"
  },

  {
    "id": "7",
    "first_name": "Floyd",
    "last_name": "Mayweather Sr",
    "nickname": "",
    "description": "With a solid record of his own, Mayweather Sr perhaps more notably coached his son Floyd who perfected the Philly Shell to rack up an unprecedented 50-0-0 record. As a coach, his padwork is fast, with extended and challenging combos.",
    "img": "images/mayweathersr.png"
  },

  {
    "id": "8",
    "first_name": "Vasiliy",
    "last_name": "Lomachenko",
    "nickname": "The Matrix",
    "description": "This Ukrainian southpaw gets his nickname from his exceptional command of the ring and what can be best described as his smooth style of boxing. His arsenal is diverse, but relies mostly on his speed and unpredictability.",
    "img": "images/lomachenko.png"
  }
]